/**
 * "N subjects" for a cohort with a processed count, or "No subjects" for one with
 * none (a cohort that has not been processed has no real count).
 */
export const getSubjectCountLabel = (subjectCount: number | null): string =>
  subjectCount !== null && subjectCount >= 0
    ? `${subjectCount.toLocaleString()} subjects`
    : 'No subjects';
